import { Box, Spacer } from '@chakra-ui/react';
import { ReactComponent as NavBarButtons } from 'assets/icons/navbar_buttons.svg';
import { UserTypes, useUser } from 'modules/User';
import { useTranslation } from 'react-i18next';

import { ShareUpgradeButton } from '../../ShareUpgradeButton';
import { SharePanelProps } from '../SharePanel/SharePanel.types';
import { SharePanel } from '../SharePanel/index';
import { UpgradeLock } from './../DownloadModal/OptionTitle';
import { PREVIEW_PANEL_MAX_HEIGHT } from './PreviewPanel.config';
import PreviewThumbnail from './PreviewThumbnail';

export const PreviewPanel = ({ onUpgrade, onClose, tabIndex, onUpgradeLock = () => {} }: SharePanelProps) => {
  const { userType } = useUser();
  const { t } = useTranslation('common_navbar');
  const upgradeText =
    userType === UserTypes.Free ? t('modals.download.upgrade-premium') : t('modals.download.upgrade-business');
  const isGated = userType === UserTypes.Free;

  return (
    <>
      {isGated && (
        <UpgradeLock
          upgradeText={upgradeText}
          handleClickUpgrade={onUpgradeLock}
          postText={t('modals.publish-panel.share-design')}
          userType={userType}
        />
      )}
      <Spacer mt={isGated ? 4 : 1} />
      <Box width='100%' overflow='hidden' pointerEvents='none' borderRadius={7} shadow={'md'}>
        <Box display={'flex'} alignItems={'center'} bg={'white'} h={5} ml={4}>
          <NavBarButtons />
        </Box>
        <Box width='100%' maxWidth={`${PREVIEW_PANEL_MAX_HEIGHT}px`} position='relative' pb={`${(9 / 16) * 100}%`}>
          <PreviewThumbnail />
        </Box>
      </Box>
      <Spacer mt={4} />
      <SharePanel onUpgrade={onUpgrade} onClose={onClose} tabIndex={tabIndex}></SharePanel>
      <Spacer mt={isGated ? 6 : 12} />
      {isGated && <ShareUpgradeButton userType={userType} tabPanel={tabIndex} />}
    </>
  );
};
